import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { trackEvent } from './utils/analytics';
import { AppRoutes } from './router';
import { useAnalyticsTracker } from './hooks/useAnalyticsTracker';
import './i18n';

function ScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const scrollToElement = () => {
        const element = document.getElementById(id);
        if (element) {
          const navbarHeight = 80; // Altura da barra de navegação fixa (h-20)
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: Math.max(0, elementPosition - navbarHeight),
            behavior: 'smooth',
          });
        }
      };

      // Dispara imediatamente e em intervalos graduais para compensar o carregamento
      // assíncrono dos componentes que vêm antes da seção de contato (Serviços, Depoimentos, etc.)
      const timeouts = [
        setTimeout(scrollToElement, 50),
        setTimeout(scrollToElement, 250),
        setTimeout(scrollToElement, 600),
        setTimeout(scrollToElement, 1000),
        setTimeout(scrollToElement, 1500),
      ];

      return () => {
        timeouts.forEach((t) => clearTimeout(t));
      };
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return null;
}

function AnalyticsTracker() {
  useAnalyticsTracker();
  
  useEffect(() => {
    const handleGlobalClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      if (anchor && anchor.href.includes('wa.me')) {
        trackEvent('click', window.location.pathname, 'whatsapp_click', { href: anchor.href });
      }
    };

    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, []);

  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollHandler />
      <AnalyticsTracker />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
